/**
 * Hook to check if user can publish a storefront document.
 * Uses backend permission API as source of truth.
 */

import { useQuery } from "@tanstack/react-query";
import { getERPClient } from "@/lib/erp/client";

type CanPublishResponse = { allowed: boolean; reason?: string | null };

export function useCanPublishQuery(doctype: string, name?: string) {
  const { data, isLoading } = useQuery({
    queryKey: ["permission", "publish", doctype, name],
    queryFn: async () => {
      const client = getERPClient();
      const res = await client.call<CanPublishResponse>(
        "zaviago_backend.api.permissions.can_publish",
        { doctype, name }
      );
      return res;
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: !!doctype,
  });

  return {
    allowed: data?.allowed ?? false,
    reason: data?.reason ?? null,
    isLoading,
  };
}

